<p-confirmDialog></p-confirmDialog>
<div class="flex flex-column gap-3">
  <p-card header="Services Configuration">
    <ng-template pTemplate="header">
      <div class="flex align-items-center justify-content-end gap-2">
        <p-button
          label="Add service"
          icon="pi pi-plus"
          (onClick)="add()"
        ></p-button>
        <p-button
          label="Export"
          icon="pi pi-download"
          (onClick)="exportServices()"
          [disabled]="!locations || locations.length === 0"
        ></p-button>
      </div>
    </ng-template>
    <p-table
      [value]="locations"
      [loading]="loading"
      dataKey="companyName"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 20, 50]"
      [globalFilterFields]="['companyName']">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="companyName">
            Service identifier
            <p-sortIcon field="companyName"/>
          </th>
          <th pSortableColumn="addressLine1">
            Location
            <p-sortIcon field="addressLine1"/>
          </th>
          <th pSortableColumn="provider">
            Provider
            <p-sortIcon field="provider"/>
          </th>
          <th pSortableColumn="serviceType">
            Service type
            <p-sortIcon field="serviceType"/>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record>
        <tr>
          <td>{{ record.companyName }}</td>
          <td>{{ record.addressLine1 }} {{ record.addressLine2 }}</td>
          <td>{{ record.provider }}</td>
          <td>{{ record.serviceType }}</td>
          <td>
            <div class="flex justify-content-end gap-1">
              <p-button
                [icon]="'pi pi-pencil'"
                [rounded]="true"
                [raised]="true"
                severity="info"
                size="small"
                title="Edit"
                (onClick)="edit(record)"
              />
              <p-button
                [icon]="'pi pi-trash'"
                [rounded]="true"
                [raised]="true"
                severity="danger"
                size="small"
                title="Delete"
                (onClick)="delete(record)"
              />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center py-7">No results found</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <p-card header="Service Products from Rev.io" *ngIf="serviceProducts.length > 0">
    <p-table
      [value]="serviceProducts"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 20, 50]"
      [globalFilterFields]="['code', 'description', 'customerName']">
      <ng-template pTemplate="header">
        <tr>
          <th>Site</th>
          <th>Product Code</th>
          <th>Description</th>
          <th>Quantity</th>
          <th>Rate</th>
          <th>Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td>{{ product.customerName }}</td>
          <td>{{ product.code }}</td>
          <td>{{ product.description }}</td>
          <td>{{ product.quantity }}</td>
          <td>{{ product.rate | currency }}</td>
          <td>
            <span [class]="product.status === 'ACTIVE' ? 'text-green-500' : 'text-red-500'">
              {{ product.status }}
            </span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center py-7">No service products found</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
<app-client-onboarding-wizard-buttons
  [nextDisabled]="false"
  (buttonClicked)="onWizardButtonClick($event)"></app-client-onboarding-wizard-buttons>
